import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/corporatePortrait/index',
    name: 'corporatePortraitIndex',
    component: () => import('@/sub-app/corporatePortrait/pages/index.vue'),
    meta: {
      title: '企业画像',
      keepAlive: false,
    },
  },
  {
    path: '/corporatePortrait/companyInfo',
    name: 'corporatePortraitCompanyInfo',
    component: () => import('@/sub-app/corporatePortrait/pages/companyInfo.vue'),
    meta: {
      title: '企业详情',
      keepAlive: false,
    },
  },
  {
    path: '/corporatePortrait/companySearch',
    name: 'corporatePortraitCompanySearch',
    component: () => import('@/sub-app/corporatePortrait/pages/companySearch.vue'),
    meta: {
      title: '搜索企业',
      keepAlive: false,
    },
  },
  {
    path: '/corporatePortrait/scoreDetails',
    name: 'corporatePortraitScoreDetails',
    component: () => import('@/sub-app/corporatePortrait/pages/scoreDetails.vue'),
    meta: {
      title: '评分详情',
      keepAlive: false,
    }
  }
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 设置webview标题
  document.title = to.meta?.title || '';
  next();
});

export default router;
